import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowUp = () => {
  return (
    <g>
      <path d="M8.005 14.998a.75.75 0 0 0 .744-.648l.006-10.79 3.967 3.965a.75.75 0 0 0 .978.072l.084-.072a.75.75 0 0 0 .072-.977l-.072-.084-5.248-5.246a.75.75 0 0 0-.977-.073l-.084.073-5.252 5.25A.75.75 0 0 0 3.2 7.6l.085-.073 3.97-3.966v10.686c0 .414.336.75.75.75z" />
    </g>
  );
};

export default withIcon(IconArrowUp);
